import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getStoreCashBook = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v2/cashbook/store',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getBrandCashBook = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v2/cashbook/brand',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};